export default function ArticlePreview() {
  const articles = [
    {
      slug: '/artigo/guia-completo-hoobuyspreadsheet',
      tag: 'Guia Completo',
      title: 'Guia Completo do HoobuySpreadsheet 2026',
      excerpt: 'Descubra como usar o Hoobuy Spreadsheet para encontrar os melhores produtos, comparar preços automaticamente e comprar com segurança em 2026. Guia passo a passo com dicas exclusivas.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20workspace%20with%20laptop%20displaying%20spreadsheet%2C%20clean%20cream%20background%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20editorial%20photography&width=800&height=500&seq=ap-v2-guia&orientation=landscape'
    },
    {
      slug: '/artigo/como-economizar-compras-online',
      tag: 'Dicas de Economia',
      title: 'Como Economizar com o HoobuySpreadsheet',
      excerpt: 'Aprenda as melhores estratégias para economizar dinheiro usando o Hoobuy Spreadsheet. Comparação de preços e compras inteligentes.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Open%20spreadsheet%20on%20laptop%20with%20coffee%20cup%20and%20notebook%2C%20savings%20concept%2C%20warm%20morning%20light%2C%20productive%20atmosphere&width=800&height=500&seq=ap-v2-economizar&orientation=landscape'
    },
    {
      slug: '/artigo/hoobuyspreadsheet-vs-concorrentes',
      tag: 'Comparativo',
      title: 'HoobuySpreadsheet vs Concorrentes',
      excerpt: 'Comparação detalhada entre o Hoobuy Spreadsheet e outras ferramentas de compras online. Entenda por que o HoobuySpreadsheet é a escolha número um.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Two%20laptops%20side%20by%20side%20showing%20different%20spreadsheets%2C%20comparison%20concept%2C%20clean%20office%20desk%2C%20bright%20workspace&width=800&height=500&seq=ap-v2-vs&orientation=landscape'
    },
    {
      slug: '/artigo/seguranca-em-compras-internacionais',
      tag: 'Segurança',
      title: 'Segurança em Compras Internacionais',
      excerpt: 'Descubra como o Hoobuy Spreadsheet garante a segurança nas suas compras internacionais. Proteção contra fraudes e links verificados.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Glass%20shield%20on%20modern%20desk%20next%20to%20laptop%2C%20warm%20ambient%20lighting%2C%20secure%20digital%20concept%2C%20trust%20theme%2C%20minimal&width=800&height=500&seq=ap-v2-seguranca&orientation=landscape'
    },
    {
      slug: '/artigo/categorias-mais-populares-hoobuy',
      tag: 'Tendências',
      title: 'Categorias Mais Populares do Hoobuy',
      excerpt: 'Conheça as categorias mais acessadas do Hoobuy Spreadsheet em 2026. Descubra quais produtos estão em alta.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20fashion%20items%20in%20neat%20grid%20on%20white%20surface%2C%20shoes%20hoodies%20caps%2C%20bright%20lighting%2C%20top%20view%2C%20clean%20photography&width=800&height=500&seq=ap-v2-categorias&orientation=landscape'
    },
    {
      slug: '/artigo/dicas-para-compras-online-2026',
      tag: 'Guia Prático',
      title: '10 Dicas para Compras Online',
      excerpt: 'Confira 10 dicas práticas para fazer compras online com inteligência usando o HoobuySpreadsheet. Maximize sua economia.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Person%20using%20smartphone%20and%20laptop%20at%20cozy%20cafe%2C%20shopping%20online%2C%20warm%20interior%20lighting%2C%20modern%20lifestyle&width=800&height=500&seq=ap-v2-dicas&orientation=landscape'
    },
    {
      slug: '/artigo/atualizacoes-hoobuyspreadsheet',
      tag: 'Novidades',
      title: 'Atualizações HoobuySpreadsheet 2026',
      excerpt: 'Fique por dentro de todas as melhorias do Hoobuy Spreadsheet. Novas funcionalidades e mais segurança para suas compras.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20spreadsheet%20on%20large%20monitor%20with%20colorful%20data%2C%20minimal%20desk%20with%20plant%2C%20bright%20workspace%2C%20tech%20vibe&width=800&height=500&seq=ap-v2-atualizacoes&orientation=landscape'
    },
    {
      slug: '/artigo/como-encontrar-melhores-ofertas',
      tag: 'Ofertas',
      title: 'Como Encontrar Melhores Ofertas',
      excerpt: 'Aprenda técnicas avançadas para encontrar as melhores ofertas usando o HoobuySpreadsheet. Dicas de especialistas.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Magnifying%20glass%20over%20spreadsheet%20with%20highlighted%20prices%2C%20coins%20calculator%2C%20warm%20light%2C%20savings%20concept&width=800&height=500&seq=ap-v2-ofertas&orientation=landscape'
    },
    {
      slug: '/artigo/tutorial-hoobuyspreadsheet-iniciantes',
      tag: 'Tutorial',
      title: 'Tutorial para Iniciantes',
      excerpt: 'Tutorial completo para iniciantes no HoobuySpreadsheet. Aprenda do zero a fazer sua primeira compra com segurança.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Laptop%20with%20beginner%20spreadsheet%20tutorial%2C%20notebook%20pen%2C%20warm%20lamp%20light%2C%20cozy%20learning%20environment&width=800&height=500&seq=ap-v2-tutorial&orientation=landscape'
    },
    {
      slug: '/artigo/beneficios-planilha-inteligente',
      tag: 'Benefícios',
      title: 'Benefícios da Planilha Inteligente',
      excerpt: 'Descubra todos os benefícios de usar uma planilha inteligente para compras. O HoobuySpreadsheet oferece economia e segurança.',
      imageUrl: 'https://readdy.ai/api/search-image?query=Neatly%20arranged%20receipts%20product%20photos%20on%20white%20desk%2C%20laptop%20checklist%2C%20morning%20light%2C%20satisfaction%20theme%2C%20clean&width=800&height=500&seq=ap-v2-beneficios&orientation=landscape'
    }
  ];

  return (
    <section className="relative py-14 md:py-20 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="mb-10 md:mb-14">
          <span className="inline-block text-xs font-semibold text-secondary-600 uppercase tracking-wider mb-3 whitespace-nowrap">
            Blog SEO & Guia
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-900 leading-tight">
            Artigos / Hoobuy / Sheet
          </h2>
          <p className="mt-4 text-foreground-500 text-sm md:text-base max-w-lg leading-relaxed">
            Conteúdo original e otimizado sobre o <strong>HoobuySpreadsheet</strong>. Guias, dicas e comparações para você comprar melhor.
          </p>
        </div>

        {/* First article - Featured */}
        <div className="mb-6">
          <a
            href={articles[0].slug}
            className="group flex flex-col md:flex-row bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
          >
            <div className="relative w-full md:w-2/5 aspect-[16/10] md:aspect-auto overflow-hidden">
              <img
                src={articles[0].imageUrl}
                alt={articles[0].title}
                title={articles[0].title}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
            </div>
            <div className="flex-1 p-5 md:p-8 flex flex-col justify-center">
              <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-3 whitespace-nowrap w-fit">
                {articles[0].tag}
              </span>
              <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 leading-snug mb-3">
                {articles[0].title}
              </h3>
              <p className="text-foreground-500 text-sm leading-relaxed mb-4">
                {articles[0].excerpt}
              </p>
              <span className="inline-flex items-center gap-2 text-primary-500 font-medium text-sm whitespace-nowrap group-hover:gap-3 transition-all">
                Ler artigo completo
                <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
              </span>
            </div>
          </a>
        </div>

        {/* Remaining articles - Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {articles.slice(1).map((article, idx) => (
            <a
              key={idx}
              href={article.slug}
              className="group flex flex-col bg-background-50 rounded-2xl overflow-hidden cursor-pointer transition-all duration-300 hover:-translate-y-1"
            >
              <div className="relative w-full aspect-[16/10] overflow-hidden">
                <img
                  src={article.imageUrl}
                  alt={article.title}
                  title={article.title}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
              </div>
              <div className="flex-1 p-4 md:p-5 flex flex-col">
                <span className="inline-block px-2.5 py-1 rounded-full bg-accent-100 text-accent-800 text-xs font-semibold mb-2.5 whitespace-nowrap w-fit">
                  {article.tag}
                </span>
                <h3 className="font-heading text-base font-semibold text-foreground-900 leading-snug mb-2 group-hover:text-primary-500 transition-colors">
                  {article.title}
                </h3>
                <p className="text-foreground-500 text-sm leading-relaxed mb-3 flex-1">
                  {article.excerpt}
                </p>
                <span className="inline-flex items-center gap-1.5 text-primary-500 font-medium text-sm whitespace-nowrap group-hover:gap-2.5 transition-all mt-auto">
                  Ler artigo
                  <i className="ri-arrow-right-line w-4 h-4 flex items-center justify-center"></i>
                </span>
              </div>
            </a>
          ))}
        </div>

        {/* View all button */}
        <div className="text-center mt-8 md:mt-10">
          <a
            href="/guia-de-compras"
            className="inline-flex items-center gap-2 px-7 py-3.5 rounded-full border-2 border-primary-500 text-primary-600 font-semibold text-sm cursor-pointer whitespace-nowrap hover:bg-primary-50 transition-all duration-200"
          >
            Ver Todos os Artigos
            <i className="ri-arrow-right-line w-5 h-5 flex items-center justify-center"></i>
          </a>
        </div>
      </div>
    </section>
  );
}